// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2fIor","content":"Consent_content__1nFtV","footer":"Consent_footer__1WOjE"};